import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { EXECUTION } from '../../../constants/execution-modes';
import { ERROR, HOMEWORK_EXECUTION, PAUSE } from '../../../constants/routes';

export const StartRoute = ({ children, executionMode, paused, resumed, started }) => {
    if (executionMode !== EXECUTION) {
        return (
            <Navigate
                to={{
                    pathname: ERROR,
                }}
            />
        );
    }

    if (paused || resumed) {
        return <Navigate to={{ pathname: PAUSE }} />;
    }

    if (started) {
        return <Navigate to={{ pathname: HOMEWORK_EXECUTION }} />;
    }

    return children;
};

StartRoute.propTypes = {
    children: PropTypes.node,
    executionMode: PropTypes.string,
    started: PropTypes.bool,
    paused: PropTypes.bool,
    resumed: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        started: state.status.started,
        executionMode: state.application.executionMode,
        paused: state.status.paused,
        resumed: state.status.resumed,
    };
};

export default connect(mapStateToProps)(StartRoute);
